export class MoleculePanelOverviewHeaderMultiDeleteRestorableEmailActionComponent {
    public templateUrl = require('./multi-delete-restorable-email-action.html?external');
}
